import React from "react";
import { useLocation } from "react-router-dom";

interface modalFaceType {
  mainTitle?: string;
  subTitle?: string | any;
  leftBtnName: string | any;
  rightBtnName: string | any;
  leftBtnFunc?: any;
  rightBtnFunc?: any;
  rightBtnColor?: any;
  backgroundColor?: any;
}

function ModalAlertBold({
  mainTitle,
  subTitle,
  leftBtnName,
  rightBtnName,
  leftBtnFunc,
  rightBtnFunc,
  rightBtnColor,
  backgroundColor,
}: modalFaceType) {
  const location = useLocation();

  return (
    <div className="modal-full-black">
      <div
        className="modal-bold"
        id={`modal-bold ${location.pathname}`}
        style={
          rightBtnColor
            ? { padding: "0", backgroundColor }
            : { backgroundColor }
        }
      >
        <p className="modal-title">{mainTitle || ""}</p>
        <div
          className="modal-desc"
          style={rightBtnColor ? { margin: "0" } : {}}
        >
          {subTitle || ""}
        </div>
        <div className="modal-button-area">
          <button
            className="left-btn"
            type="button"
            onClick={() => leftBtnFunc()}
          >
            {leftBtnName || "취소"}
          </button>
          <button
            className="right-btn"
            id={`right-btn ${location.pathname}`}
            style={
              rightBtnColor
                ? {
                    backgroundColor: rightBtnColor,
                    color: "#6C7279",
                    borderLeft: "1px solid #C9CDD2",
                  }
                : { backgroundColor: "#642FFA" }
            }
            type="button"
            onClick={() => rightBtnFunc()}
          >
            {rightBtnName || "확인"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalAlertBold;
